// extracted by mini-css-extract-plugin
export default {"container":"VideoUpNext-styles-module__container__J6opr"};